const internalTransferStatuses: { [key: string]: string } = {
  approved: 'Approved',
  processed: 'Processed',
  cancelled: 'Cancelled',
  pending_approval: 'Pending Approval',
  exported: 'Exported'
}

export const getInternalTransferStatusLabel = (name: string) => internalTransferStatuses[name] || name
